/**
 * Created by heldernunes on 22/12/2016.
 * Refactored by cristiano.faria on 24/03/2017.
 */
GlobalTranslations = {

    init: function () {
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.1', 'emptyFieldError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.2', 'shortValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.3', 'maxValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.4', 'cloneValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.5', 'numericValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.6', 'dateValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.7', 'hourValueError');
        GlobalTranslations.get_translation_for('FORM_VALIDATOR_LABEL.8', 'numericOutOfRangeError');
        GlobalTranslations.get_translation_for('WARNING.92', 'slotOcuppied');
        GlobalTranslations.get_translation_for('WARNING.86', 'slotPlanned');

        //Patient form
        GlobalTranslations.get_translation_for('APP_LABEL.3001', 'APP_LABEL.3001');

        //blood_requisition
        GlobalTranslations.get_translation_for('APP_LABEL.2299', 'appLabel2299'); //Blood work has already been performed.
        GlobalTranslations.get_translation_for('APP_LABEL.2300', 'appLabel2300'); //There are no items to return.
        GlobalTranslations.get_translation_for('APP_LABEL.2301', 'appLabel2301'); //There are no items to be transferred.

        //KADSE alert messages
        GlobalTranslations.get_translation_for('APP_LABEL.2991', 'APP_LABEL.2991');
        GlobalTranslations.get_translation_for('APP_LABEL.2992', 'APP_LABEL.2992');
        GlobalTranslations.get_translation_for('APP_LABEL.2997', 'APP_LABEL.2997');
        GlobalTranslations.get_translation_for('APP_LABEL.2998', 'APP_LABEL.2998');

        //PEM alert messages
        GlobalTranslations.get_translation_for('APP_LABEL.2169', 'APP_LABEL.2169');
        GlobalTranslations.get_translation_for('APP_LABEL.2170', 'APP_LABEL.2170');
        GlobalTranslations.get_translation_for('APP_LABEL.2313', 'APP_LABEL.2313');
        GlobalTranslations.get_translation_for('APP_LABEL.2314', 'APP_LABEL.2314');
        GlobalTranslations.get_translation_for('APP_LABEL.2315', 'APP_LABEL.2315');
        GlobalTranslations.get_translation_for('APP_LABEL.2316', 'APP_LABEL.2316');
        GlobalTranslations.get_translation_for('APP_LABEL.2445', 'APP_LABEL.2445');
        GlobalTranslations.get_translation_for('APP_LABEL.2388', 'APP_LABEL.2388');

        //multiSelect
        GlobalTranslations.get_translation_for('APP_LABEL.2451', 'MultiSelectAddAll');
        GlobalTranslations.get_translation_for('APP_LABEL.2452', 'MultiSelectRemoveAll');
        GlobalTranslations.get_translation_for('APP_LABEL.2453', 'MultiSelectitemsCount');

        //participantSelector
        GlobalTranslations.get_translation_for('APP_LABEL.2450', 'APP_LABEL.2450');
        GlobalTranslations.get_translation_for('APP_LABEL.2454', 'APP_LABEL.2454');

        GlobalTranslations.get_translation_for('APP_LABEL.2455', 'APP_LABEL.2455');

        GlobalTranslations.get_translation_for('APP_LABEL.TREATMENT_ALREADY_INVOICED', 'APP_LABEL.TREATMENT_ALREADY_INVOICED');

        //inpatientNS
        GlobalTranslations.get_translation_for('APP_LABEL.2494', 'APP_LABEL.2494');

        //nosologicGroups
        GlobalTranslations.get_translation_for('APP_LABEL.2449', 'appLabel2449');

        GlobalTranslations.get_translation_for('APP_LABEL.2532', 'APP_LABEL.2532');

        // Patient Medication
        GlobalTranslations.get_translation_for('APP_LABEL.2626', 'APP_LABEL.2626');

        GlobalTranslations.get_translation_for('APP_LABEL.573', 'APP_LABEL.573'); //Additional information

        GlobalTranslations.get_translation_for('APP_LABEL.2712', 'APP_LABEL.2712'); //Invoice entity

        GlobalTranslations.get_translation_for('APP_LABEL.2716', 'APP_LABEL.2716'); //Additional Clinical Information
        GlobalTranslations.get_translation_for('APP_LABEL.2755', 'APP_LABEL.2755'); //The request can not be canceled because there are already verified requests.

        GlobalTranslations.get_translation_for('APP_LABEL.2756', 'APP_LABEL.2756'); //The request can not be canceled because there are already verified requests.

        GlobalTranslations.get_translation_for('APP_LABEL.2777', 'APP_LABEL.2777'); //Calendar, slot restriction limit message
        GlobalTranslations.get_translation_for('APP_LABEL.2780', 'APP_LABEL.2780'); // Cancel Conference
        GlobalTranslations.get_translation_for('APP_LABEL.2493', 'APP_LABEL.2493');
        GlobalTranslations.get_translation_for('APP_LABEL.936', 'APP_LABEL.936'); // Cancel Generic Label
        GlobalTranslations.get_translation_for('APP_LABEL.2784', 'APP_LABEL.2784'); // Cancel Reimb. Requisition - Cancel Payment
        GlobalTranslations.get_translation_for('APP_LABEL.2788', 'APP_LABEL.2788');
        GlobalTranslations.get_translation_for('APP_LABEL.2953', 'APP_LABEL.2953');
        GlobalTranslations.get_translation_for('APP_LABEL.REIMBURSEMENT_MANAGEMENT.REQUEST_INFORMATION', 'APP_LABEL.REIMBURSEMENT_MANAGEMENT.REQUEST_INFORMATION');
        GlobalTranslations.get_translation_for('APP_LABEL.267', 'APP_LABEL.267');
        GlobalTranslations.get_translation_for('APP_LABEL.165', 'APP_LABEL.165');


        GlobalTranslations.get_translation_for('APP_LABEL.299', 'APP_LABEL.299'); //PEM price patient
        GlobalTranslations.get_translation_for('APP_LABEL.792', 'APP_LABEL.792'); //PEM price sns

        GlobalTranslations.get_translation_for('APP_LABEL.PEM.SPMS_AUTH_FAIL', 'APP_LABEL.PEM.SPMS_AUTH_FAIL');
        GlobalTranslations.get_translation_for('APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN', 'APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN');
        GlobalTranslations.get_translation_for('APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN_IF_FAIL_CALL_ADMIN', 'APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN_IF_FAIL_CALL_ADMIN');

        GlobalTranslations.get_translation_for('CARD_SERVICE.WARNING.BROKEN_RESPONSE', 'CARD_SERVICE.WARNING.BROKEN_RESPONSE');
        GlobalTranslations.get_translation_for('CARD_SERVICE.WARNING.CARD_NOT_FOUND', 'CARD_SERVICE.WARNING.CARD_NOT_FOUND');
        GlobalTranslations.get_translation_for('CKR_SESSION_HANDLE_INVALID', 'CKR_SESSION_HANDLE_INVALID');
        GlobalTranslations.get_translation_for('CKR_USER_NOT_LOGGED_IN', 'CKR_USER_NOT_LOGGED_IN');
        GlobalTranslations.get_translation_for('CKR_DEVICE_REMOVED', 'CKR_DEVICE_REMOVED');
        GlobalTranslations.get_translation_for('CKR_SESSION_CLOSED', 'CKR_SESSION_CLOSED');
        GlobalTranslations.get_translation_for('CARD_SERVICE.WARNING.EXPIRED_CARD', 'CARD_SERVICE.WARNING.EXPIRED_CARD');
        
        //BANDS
        GlobalTranslations.get_translation_for('APP_LABEL.ERROR_IMPORT_BAND', 'APP_LABEL.ERROR_IMPORT_BAND');
        GlobalTranslations.get_translation_for('APP_LABEL.ALERT.STOCK_INTEGRATION.OFFLINE_SERVICE', 'APP_LABEL.ALERT.STOCK_INTEGRATION.OFFLINE_SERVICE');

        // Integrations

        GlobalTranslations.get_translation_for('APP_LABEL.INTEGRATIONS.APPOINTMENT.SUCCESS', 'APP_LABEL.INTEGRATIONS.APPOINTMENT.SUCCESS');
        GlobalTranslations.get_translation_for('APP_LABEL.INTEGRATIONS.APPOINTMENT.ERROR', 'APP_LABEL.INTEGRATIONS.APPOINTMENT.ERROR');
    },

    get_translation_for: function (key, keyType) {

        if (!GlobalTranslations[keyType]){

            $.get('/khis_util/get_translation_js', {key: key}, null, "html")
                .done(function(data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    var _data = $.parseJSON(data);
                    GlobalTranslations.setKey(keyType, _data.app_label);
                });

        } else {
            //Check Language change if it is needed
            debug.log('GlobalTranslations.get_translation_for :: ELSE ');
        }

    },

    setKey: function (keyType, message) {

        GlobalTranslations[keyType] = message;

    }
};

jQuery(function () {
    GlobalTranslations.init();
});


